module.exports = __webpack_public_path__ + "assets/b83d2d1fbdaa9ed863d9a4224967b305.mp3";